export default "__VITE_ASSET__m9bP0EP6__"